import { Container, type ContainerProps, Stack, type Theme, useMediaQuery } from '@mui/material';
import Breadcrumbs from '/@/components/bayer/breadcrumbs';
import PageContainer from '/@/components/bayer/page-container';
import type { Breadcrumb } from '/@/hooks/breadcrumbs';
import { HELP_CENTER_PAGE_BG } from './constants';
import { HelpCenterReportProblemLink } from './report-problem-link';

const HelpCenterContainer = ({
    children,
    breadcrumbs,
    maxWidth = 'xl',
}: {
    children: React.ReactNode;
    breadcrumbs?: Breadcrumb[];
    maxWidth?: ContainerProps['maxWidth'];
}) => {
    const isXsOrLower = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    return (
        <PageContainer
            heroHeader={
                <Container maxWidth={'xl'} sx={{ pt: 4 }}>
                    <Stack direction='row' justifyContent='space-between' alignItems='flex-start' width='100%'>
                        <Stack direction='column' spacing={1}>
                            {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumbs breadcrumbs={breadcrumbs} />}
                        </Stack>
                        <HelpCenterReportProblemLink />
                    </Stack>
                </Container>
            }
            boxProps={{ sx: { bgcolor: HELP_CENTER_PAGE_BG, minHeight: '100%', mb: 5 } }}
            containerProps={{ maxWidth, sx: { pt: isXsOrLower ? 0 : 2 } }}
        >
            {children}
        </PageContainer>
    );
};

export default HelpCenterContainer;
